<template>
    <div id="homepage" class="homepage">
        <HomeHero/>

        <ToolOverview />

        <HowItWorks />

        <TrustedBy />

        <CallToAction
            :copy="'Are you a large organization looking for a more bespoke Khonsu package?  No problem.  Contact us here if you want to discuss.'"
            :button-text="'Contact us here'"
            :button-link="'/contact'"
        />

        <ReviewsSection />

        <GetStarted />

        <TipsTricks />
    </div>
</template>

<script>
    import HomeHero from '@/views/HomePage/HomeHero';
    import ToolOverview from "@/views/HomePage/ToolOverview";
    import TrustedBy from "@/views/HomePage/TrustedBy";
    import HowItWorks from "@/views/HomePage/HowItWorks";
    import CallToAction from "@/components/layout/CallToAction";
    import ReviewsSection from "@/views/HomePage/ReviewsSection";
    import GetStarted from "@/components/layout/GetStarted";
    import TipsTricks from "@/views/HomePage/TipsTricks";

    export default {
        name: 'AppHome',
        components: {
            HomeHero,
            ToolOverview,
            TrustedBy,
            HowItWorks,
            CallToAction,
            ReviewsSection,
            GetStarted,
            TipsTricks
        }
    }
</script>